import { createAction } from 'redux-actions';

import * as actionTypes from './actionTypes';

export const googleAuthInitialized = createAction(actionTypes.INITIALIZATION_GOOGLE_AUTH);
